"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
var _Utils = require("../api/Utils");
var _AuthComponentLoader = _interopRequireDefault(require("../components/auth/AuthComponentLoader"));
var _ApplicationContext = require("../api/ApplicationContext");
var _AuthenticationController = _interopRequireWildcard(require("../api/auth/AuthenticationController"));
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _SecurityContextLogoutHandler = require("../api/SecurityContextLogoutHandler");
var _MessageResolver = require("../api/MessageResolver");
var _AzureStatus = require("../api/azure/AzureStatus");
var _AuthenticationConfiguration = require("../api/auth/AuthenticationConfiguration");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _authenticationController = /*#__PURE__*/new WeakMap();
class Login extends _react.default.Component {
  constructor(props) {
    super(props);
    _classPrivateFieldInitSpec(this, _authenticationController, null);
    _defineProperty(this, "initialize", () => {
      const {
        isFromSuperUser,
        isFromMarketingRep
      } = this.props;
      const clientId = (0, _AuthenticationController.getClientId)(isFromMarketingRep, isFromSuperUser);
      (0, _AuthenticationConfiguration.getConfiguration)(clientId).then(authConfiguration => {
        _ApplicationContext.ApplicationContext.setAzureApplicationId(authConfiguration.azureClientId);
        _ApplicationContext.ApplicationContext.setAzureTenantId(authConfiguration.azureTenantId);
        const autoInitiate = _ApplicationContext.ApplicationContext.isAutoInitiateLogin() || authConfiguration.autoInitiateEnabled;
        this.setState({
          initialized: true,
          autoInitiate,
          azureEnabled: authConfiguration.azureSSOEnabled,
          showFramework: !authConfiguration.azureSSOEnabled
        });
        this.finishMounting(autoInitiate);
      }).catch(() => {
        // For now, just swallow the error and let the login button display
        this.setState({
          initialized: true
        });
        this.finishMounting(false);
      });
    });
    _defineProperty(this, "finishMounting", autoInitiate => {
      const {
        isFromLogout
      } = this.props;
      const azureStatus = _AzureStatus.AzureStatus.get();
      if (_ApplicationContext.ApplicationContext.isLoginDataService()) {
        var _this$props;
        this.setState({
          isLoading: true,
          mounted: true
        });
        if (((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.isFromMarketingRep) === true) {
          (0, _Utils.getSalesLoginData)().then(response => {
            var _response$data, _response$data2;
            this.setState({
              isLoading: false,
              siteTagValue: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.siteTag,
              siteDescriptionValue: response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.siteDescription
            });
          }).catch(() => {
            this.setState({
              isLoading: false,
              siteTagValue: '',
              siteDescriptionValue: ''
            });
          });
        } else {
          (0, _Utils.getLoginData)().then(response => {
            var _response$data3, _response$data4;
            this.setState({
              isLoading: false,
              siteTagValue: response === null || response === void 0 || (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.siteTag,
              siteDescriptionValue: response === null || response === void 0 || (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.siteDescription
            });
          }).catch(() => {
            this.setState({
              isLoading: false,
              siteTagValue: '',
              siteDescriptionValue: ''
            });
          });
        }
      } else {
        const {
          azureEnabled
        } = this.state;
        const isLogoutInitiated = typeof isFromLogout !== 'undefined' && isFromLogout;
        let logoutPerformed = _ApplicationContext.ApplicationContext.getContext('login.stage.logoutPerformed');
        if (typeof logoutPerformed !== 'string') {
          logoutPerformed = 'false';
        } else if (!isLogoutInitiated) {
          _ApplicationContext.ApplicationContext.setContext('login.stage.logoutPerformed', 'false');
        }

        // This currently has some Azure specific code.  Might work to limit this.
        if (!isLogoutInitiated && logoutPerformed !== 'true' && azureStatus.isNew() && autoInitiate) {
          this.setState({
            mounted: true,
            isLoading: true,
            showFramework: !azureEnabled
          });
          this.proceed(this);
        } else if (azureStatus.isComplete() || azureStatus.isAuthenticationReady()) {
          this.setState({
            mounted: true,
            showFramework: false
          });
        } else {
          _ApplicationContext.ApplicationContext.showFramework(true);
          this.setState({
            mounted: true,
            showFramework: true
          });
        }
      }
    });
    _defineProperty(this, "sendToLoginRoute", () => {
      const {
        logoutSuccessPath
      } = this.props;
      _classPrivateFieldSet(_authenticationController, this, new _AuthenticationController.default(this));
      this.setState({
        authFailure: false,
        authComponent: 'InitializeAuthentication'
      });
      this.props.history.push(logoutSuccessPath ?? _ApplicationContext.ApplicationContext.getLoginPath());
    });
    const _azureStatus = _AzureStatus.AzureStatus.get();
    _classPrivateFieldSet(_authenticationController, this, new _AuthenticationController.default(this, _azureStatus.isAuthenticationReady()));
    this.state = {
      initialized: false,
      mounted: false,
      autoInitiate: false,
      showFramework: true,
      authFailure: false,
      azureEnabled: false,
      authComponent: _classPrivateFieldGet(_authenticationController, this).getNextStep(),
      isLoading: false,
      siteTagValue: '',
      siteDescriptionValue: ''
    };
    this.proceed = this.proceed.bind(this);
    this.sendToLoginRoute = this.sendToLoginRoute.bind(this);
    _ApplicationContext.ApplicationContext.setClientIdFromParam('client');
  }
  componentDidMount() {
    const {
      initialized,
      mounted,
      autoInitiate
    } = this.state;
    if (!initialized) {
      this.initialize();
    } else if (!mounted) {
      this.finishMounting(autoInitiate);
    }
  }
  proceed(stepListener, step) {
    const {
      isFromSuperUser,
      isFromMarketingRep
    } = this.props;
    if (step == null) {
      _classPrivateFieldGet(_authenticationController, this).initialize(stepListener, isFromSuperUser, isFromMarketingRep);
    } else {
      _classPrivateFieldGet(_authenticationController, this).proceed(stepListener, step);
    }
  }
  componentWillUnmount() {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
    }
  }
  render() {
    const {
      isFromLogout,
      loginHeroContent,
      loginLogo,
      loginAddon,
      customMessageResolver,
      loginHeroPosition,
      loginContentLeft,
      loginContentRight,
      loginContentTop,
      loginContentBottom,
      isLoginContentVCentered
    } = this.props;
    const {
      authComponent,
      authFailure,
      stepResponse,
      statusCode,
      message,
      isLoading,
      siteTagValue,
      siteDescriptionValue,
      showFramework,
      autoInitiate,
      mounted
    } = this.state;
    if (!mounted) {
      // We don't want to render anything until we are sure of what to render
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    const content = (0, _AuthComponentLoader.default)(authComponent, this.proceed, stepResponse, this.props);
    const azureStatus = _AzureStatus.AzureStatus.get();
    let lclAuthFailure = authFailure;
    let lclErrorMessage = message;
    if (!authFailure && azureStatus.isErrant()) {
      lclAuthFailure = true;
      lclErrorMessage = azureStatus.getMessage();
    }
    if (lclAuthFailure) {
      _SecurityContextHolder.SecurityContextHolder.reset();
      const logoutMessage = /*#__PURE__*/_react.default.createElement("div", {
        className: "columns is-mobile"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "column is-1 icon is-right has-text-danger"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons is-size-1"
      }, "error")), /*#__PURE__*/_react.default.createElement("div", {
        className: "column is-11 "
      }, /*#__PURE__*/_react.default.createElement(_MessageResolver.MessageResolver, {
        statusCode: statusCode,
        message: lclErrorMessage,
        customMessageResolver: customMessageResolver,
        defaultMessage: "We were unable to authenticate you to the application at this time. Please try again later."
      })));
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.OkModal, {
        header: "Authentication Failure",
        message: logoutMessage,
        closeModalCallback: this.sendToLoginRoute
      }));
    }
    if (isFromLogout) {
      _SecurityContextLogoutHandler.SecurityContextLogoutHandler.logout();
      _ApplicationContext.ApplicationContext.setContext('login.stage.logoutPerformed', true);
      const logoutMessage = /*#__PURE__*/_react.default.createElement("div", null, "You have successfully logged out of the site. Thank you for working with us and we look forward to helping you again soon!");
      if (_ApplicationContext.ApplicationContext.getDefaultLoginMethod() === 'token') {
        return /*#__PURE__*/_react.default.createElement(_core.InfoNotification, {
          status: "Logout Successful!",
          footer: _ApplicationContext.ApplicationContext.getOverrideDefaultPath() && /*#__PURE__*/_react.default.createElement(_core.Button, {
            className: "button is-primary",
            handleClick: this.sendToLoginRoute
          }, "OK")
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "columns is-centered mb-2"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "column is-half-desktop"
        }, logoutMessage)));
      }
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.OkModal, {
        header: "Logout Successful!",
        message: logoutMessage,
        closeModalCallback: this.sendToLoginRoute
      }));
    }
    if (!showFramework && autoInitiate && authComponent === 'InitializeAuthentication') {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    if (!showFramework) {
      return /*#__PURE__*/_react.default.createElement("div", null, content);
    }

    // Basic Login Templating
    //                    loginContentTop
    // loginContentLeft   LoginBox              loginContentRight
    //                    loginContentBottom
    if (loginContentTop || loginContentBottom || loginContentLeft || loginContentRight) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "login-wrapper"
      }, loginContentTop && /*#__PURE__*/_react.default.createElement("div", {
        className: "login-top-container"
      }, loginContentTop), /*#__PURE__*/_react.default.createElement("div", {
        className: `login columns is-desktop ${isLoginContentVCentered ? 'is-vcentered' : ''}`
      }, loginContentLeft && /*#__PURE__*/_react.default.createElement("div", {
        className: "column login-column-left"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "login-left-container"
      }, loginContentLeft)), /*#__PURE__*/_react.default.createElement("div", {
        className: "column login-box-column"
      }, /*#__PURE__*/_react.default.createElement("article", {
        className: "login-box-container"
      }, content)), loginContentRight && /*#__PURE__*/_react.default.createElement("div", {
        className: "column login-column-right"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "login-right-container"
      }, loginContentRight))), loginContentBottom && /*#__PURE__*/_react.default.createElement("div", {
        className: "login-bottom-container"
      }, loginContentBottom));
    }
    if (loginHeroPosition === 'right' && loginHeroContent) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "login-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "login columns is-desktop is-vcentered"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "column login-box-column"
      }, /*#__PURE__*/_react.default.createElement("article", {
        className: "login-box-container"
      }, loginHeroContent && loginLogo, content)), loginHeroContent), loginAddon && /*#__PURE__*/_react.default.createElement("div", {
        className: "login-addon columns"
      }, loginAddon));
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "login columns is-desktop is-vcentered"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: ` ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), loginHeroContent || /*#__PURE__*/_react.default.createElement("div", {
      className: "column"
    }, /*#__PURE__*/_react.default.createElement("section", {
      className: "hero"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hero-body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement("h1", {
      className: "title has-text-weight-normal"
    }, !_ApplicationContext.ApplicationContext.isLoginDataService() ? (0, _reactHtmlParser.default)(_ApplicationContext.ApplicationContext.getSiteTag()) : siteTagValue, ' '), /*#__PURE__*/_react.default.createElement("h2", {
      className: "subtitle has-text-weight-normal"
    }, !_ApplicationContext.ApplicationContext.isLoginDataService() ? (0, _reactHtmlParser.default)(_ApplicationContext.ApplicationContext.getSiteDescription()) : siteDescriptionValue))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "column login-box-column"
    }, /*#__PURE__*/_react.default.createElement("article", {
      className: "login-box-container"
    }, loginHeroContent && loginLogo, content))), loginAddon && /*#__PURE__*/_react.default.createElement("div", {
      className: "login-addon is-hidden-mobile"
    }, loginAddon));
  }
}
Login.propTypes = {
  isFromLogout: _propTypes.default.bool,
  isFromSuperUser: _propTypes.default.bool,
  isFromMarketingRep: _propTypes.default.bool,
  loginHeroPosition: _propTypes.default.string,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  loginAuthenticationHelp: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginHeroContent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginLogo: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginAddon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginContentLeft: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginContentRight: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginContentTop: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginContentBottom: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  isLoginContentVCentered: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  customMessageResolver: _propTypes.default.func,
  logoutSuccessPath: _propTypes.default.string
};
Login.defaultprops = {
  isFromLogout: false,
  loginHeroContent: undefined,
  loginHeroPosition: 'left',
  loginLogo: undefined,
  loginAddon: undefined,
  customMessageResolver: undefined,
  logoutSuccessPath: _ApplicationContext.ApplicationContext.getLoginPath()
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(Login);
//# sourceMappingURL=Login.js.map